exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index_swiperWrap_175RM {\n  width: 100%;\n  position: relative;\n}\n\n.index_swiperWrap_175RM * {\n  direction: ltr;\n  unicode-bidi: normal;\n  text-align: center;\n}\n", ""]);

// Exports
exports.locals = {
	"swiperWrap": "index_swiperWrap_175RM"
};